// Repeating the SAME clientMsgId is safe: the server's durable idempotency
// record prevents a lost HTTP response from becoming a second WhatsApp send.
const RETRY_DELAYS_MS = [1000, 3000, 6000, 12000];

export async function postQueuedText(body, {
  request = fetch,
  pause = ms => new Promise(resolve => setTimeout(resolve, ms)),
  shouldContinue = () => true,
} = {}) {
  let priorAttemptUncertain = false;
  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1) {
    if (!shouldContinue()) return { uncertain:true };
    try {
      const response = await request('/api/send-message', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json().catch(() => null);
      // A proxy's HTML 429 can reject the request before it reaches our server.
      // An invalid response body (including 5xx) can also hide an accepted POST.
      // Retry only this short-lived transport ambiguity, always with the same ID.
      const transient = response.status === 429
        || (!data && (response.ok || [408, 425].includes(response.status) || response.status >= 500));
      if (transient) {
        priorAttemptUncertain = true;
        if (attempt < RETRY_DELAYS_MS.length) {
          await pause(RETRY_DELAYS_MS[attempt]);
          continue;
        }
        return { uncertain:true, response, data };
      }
      // An explicit error on the first attempt is shown as before. Once an
      // earlier POST's outcome is unknown, a later error (even a 401) cannot
      // prove that the first one did not enter the queue.
      if (priorAttemptUncertain && !data?.ok) return { uncertain:true, response, data };
      return { response, data, uncertain:false };
    } catch (error) {
      priorAttemptUncertain = true;
      if (attempt < RETRY_DELAYS_MS.length) {
        await pause(RETRY_DELAYS_MS[attempt]);
        continue;
      }
      return { uncertain:true };
    }
  }
  return { uncertain:true };
}